module.exports = __webpack_public_path__ + "static/media/goodfrac_diagram.16101518.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/info/goodfrac_diagram.png
// module id = 2357
// module chunks = 0